import { AccountInvoiceDTO } from '../dto/account-invoice.dto';

export class AccountInvoice {
  public static fromDto(invoice: AccountInvoiceDTO): AccountInvoice {
    return new AccountInvoice(
      invoice.oid,
      invoice.total,
      invoice.payable,
      invoice.paid
    );
  }

  constructor(
    public id: number,
    public total: number,
    public payable: boolean,
    public paid: boolean
  ) {}
}
